import colors, { withOpacity } from '../../utils/colors';
import type { CommonSwitchProps, SwitchVariant } from './types';

export type GetBackgroundColorParams = {
  isChecked: CommonSwitchProps['isChecked'];
  variant: SwitchVariant;
  gradient?: string;
};

export const getBackgroundColor = ({ isChecked, variant, gradient }: GetBackgroundColorParams) => {
  switch (variant) {
    case 'pink':
      return isChecked ? colors.pink120 : withOpacity(colors.ink100, 0.2);
    case 'primary':
    default:
      return isChecked ? gradient : colors.ink20;
  }
};
